// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_Wqq","cls2":"AuthorsCard-cls2_j-i AuthorsCard-cls1_Wqq","altLook":"AuthorsCard-altLook_Nfw"};